<template>
  <div>
      <h1 class="title is-1 mu-font">
        MUCRISIS
      </h1>
      <h2 class="subtitle">
        ¡Disfruta tu estadía!
      </h2>
      <span v-tooltip.bottom="{ content: server.cs && server.gs ? 'Servidor En Línea':'Servidor Apagado' }">
        <fa 
        icon="power-off" 
        :class="['is-size-4 is-unselectable', server.cs && server.gs ? 'has-text-primary':'has-text-danger']" />
      </span>
      <br><br>
      <span class="tag is-large is-primary is-light mu-font is-uppercase">jugadores online [<b>{{accounts}}</b>]</span>
      <hr>
      <p class="title is-4">Mención honorífica</p>
      <div class="columns is-mobile">
          <div class="column">
            <div class="box back-white">
                <b>Jugadores</b><br>
                <hr class="custom-divisor2">
                <br>
                <p v-for="(player,n) in players" :key="n">{{player.name}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box back-white">
                <b>Gremios</b><br>
                <hr class="custom-divisor2">
                <br>
                <p v-for="(guild,n) in guilds" :key="n">{{guild.name}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box back-white">
                <b>Asesinos</b><br>
                <hr class="custom-divisor2">
                <br>
                <p v-for="(pker,n) in pkers" :key="n">{{pker.name}}</p>
            </div>
          </div>
      </div>
      <hr>
        <div class="buttons has-addons is-centered">
            <a href="https://mucrisis.com/comandos" target="_blank" class="button is-link is-light"><fa icon="code" />&nbsp;Ver Comandos</a>
            <a href="https://mucrisis.com/ranking" target="_blank" class="button is-link is-light"><fa icon="trophy" />&nbsp;Ver Ranking</a>
            <a href="https://mucrisis.com/contacto" target="_blank" class="button is-link is-light"><fa icon="location-arrow" />&nbsp;Contacto</a>
        </div>
  </div>
</template>

<script>
export default {
    name: 'LauncherView',
    computed: {
        server() {
            return this.$store.getters.GetServerInfo
        },
        api() {
            return this.$store.getters.GetApiPath
        },
        accounts() {
            return this.$store.getters.GetMemberStatus
        },
        players() {
            return this.$store.getters.GetTop3Player
        },
        guilds() {
            return this.$store.getters.GetTop3Guild
        },
        pkers() {
            return this.$store.getters.GetTop3Pker
        }
    }
}
</script>

<style scoped>
    .column {
        padding-left: 0.21rem !important;
        padding-right: 0.21rem !important;
    }


</style>